import React from 'react';
import { Box, Typography } from '@mui/material';
import InboxRoundedIcon from '@mui/icons-material/InboxRounded';

export const BrandedDataGridOverlay: React.FC = () => {
    return (
        <Box
            sx={{
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                px: 3,
                py: 4,
                textAlign: 'center',
            }}
        >
            <Box
                sx={{
                    borderRadius: 2,
                    border: '1px dashed',
                    borderColor: 'divider',
                    backgroundColor: '#fbfaf8',
                    px: { xs: 3, md: 4 },
                    py: { xs: 2.5, md: 3 },
                    maxWidth: 420,
                }}
            >
                <Box
                    sx={{
                        width: 44,
                        height: 44,
                        mx: 'auto',
                        mb: 1.5,
                        borderRadius: '50%',
                        backgroundColor: 'rgba(64, 115, 37, 0.12)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'primary.main',
                    }}
                >
                    <InboxRoundedIcon fontSize="small" />
                </Box>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 0.5 }}>
                    Keine Einträge
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Es wurden keine Daten gefunden. Sobald Einträge vorhanden sind, erscheinen sie hier.
                </Typography>
            </Box>
        </Box>
    );
};
